var escapeRegExp, initRegExp, normalizeQuery, regexp, replacements;

escapeRegExp = require('../../../../../core/frontend/common/underscore_mixins').escapeRegExp;

regexp = replacements = null;

initRegExp = function() {
  var char, charMap, dest, i, key, len, len1, src, val;
  charMap = window.Groupon.LS.data.charMapping || {};
  replacements = {};
  regexp = '';
  val = _.values(charMap);
  key = _.keys(charMap);
  regexp = new RegExp('[' + escapeRegExp(val.join('')) + ']', 'g');
  len = val.length;
  while (len--) {
    src = val.pop();
    dest = key.pop();
    for (i = 0, len1 = src.length; i < len1; i++) {
      char = src[i];
      replacements[char] = dest;
    }
  }
  return regexp;
};

module.exports = normalizeQuery = function(s) {
  if (typeof s !== 'string') {
    return '';
  }
  s = s.trim().replace(regexp || initRegExp(), function(c) {
    return replacements[c];
  });
  return s.toLowerCase();
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvaGVscGVyL21fbm9ybWFsaXplUXVlcnkuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvaGVscGVyL21fbm9ybWFsaXplUXVlcnkuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUMsZUFBZ0IsT0FBQSxDQUFRLHVEQUFSOztBQUNqQixNQUFBLEdBQVMsWUFBQSxHQUFlOztBQUV4QixVQUFBLEdBQWEsU0FBQTtBQUVYLE1BQUE7RUFBQSxPQUFBLEdBQVUsTUFBTSxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLFdBQXZCLElBQXNDO0VBRWhELFlBQUEsR0FBZTtFQUNmLE1BQUEsR0FBUztFQUVULEdBQUEsR0FBTSxDQUFDLENBQUMsTUFBRixDQUFTLE9BQVQ7RUFDTixHQUFBLEdBQU0sQ0FBQyxDQUFDLElBQUYsQ0FBTyxPQUFQO0VBQ04sTUFBQSxHQUFjLElBQUEsTUFBQSxDQUFPLEdBQUEsR0FBTSxZQUFBLENBQWEsR0FBRyxDQUFDLElBQUosQ0FBUyxFQUFULENBQWIsQ0FBTixHQUFtQyxHQUExQyxFQUErQyxHQUEvQztFQUNkLEdBQUEsR0FBTSxHQUFHLENBQUM7QUFDVixTQUFNLEdBQUEsRUFBTjtJQUNFLEdBQUEsR0FBTSxHQUFHLENBQUMsR0FBSixDQUFBO0lBQ04sSUFBQSxHQUFPLEdBQUcsQ0FBQyxHQUFKLENBQUE7QUFDUCxTQUFBLHVDQUFBOztNQUFBLFlBQWEsQ0FBQSxJQUFBLENBQWIsR0FBcUI7QUFBckI7RUFIRjtTQUtBO0FBaEJXOztBQWtCYixNQUFNLENBQUMsT0FBUCxHQUFpQixjQUFBLEdBQWlCLFNBQUMsQ0FBRDtFQUNoQyxJQUFpQixPQUFPLENBQVAsS0FBWSxRQUE3QjtBQUFBLFdBQU8sR0FBUDs7RUFDQSxDQUFBLEdBQUksQ0FBQyxDQUFDLElBQUYsQ0FBQSxDQUFRLENBQUMsT0FBVCxDQUFrQixNQUFBLElBQVUsVUFBQSxDQUFBLENBQTVCLEVBQTJDLFNBQUMsQ0FBRDtXQUM3QyxZQUFhLENBQUEsQ0FBQTtFQURnQyxDQUEzQztTQUVKLENBQUMsQ0FBQyxXQUFGLENBQUE7QUFKZ0MifQ==
